import type { ElementType, ReactNode } from 'react'

type SectionProps<T extends ElementType> = {
  as?: T
  id?: string
  className?: string
  children: ReactNode
}

function Section<T extends ElementType = 'section'>(
  { as, id, className, children }: SectionProps<T>
) {
  const Comp = as ?? 'section'
  const classes = ['w-full', className].filter(Boolean).join(' ')

  return (
    <Comp id={id} className={classes}>
      {children}
    </Comp>
  )
}

export default Section
